import { motion } from "framer-motion";
import { Leaf, Droplets, Heart, Globe2, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";

const Ingredients = () => {
  const { t } = useLang();

  const icons = [Leaf, Droplets, Heart, Globe2, ShieldCheck];

  return (
    <section
      data-testid="ingredients-section"
      className="relative py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="flex items-center gap-4 mb-14 md:mb-20"
        >
          <span className="w-12 h-px bg-[#0F3D2E]/50" />
          <div className="font-eyebrow text-2xl md:text-[30px] text-[#0F3D2E]/85">
            {t.ingredients.eyebrow}
          </div>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-6">
          {t.ingredients.pills.map((label, i) => {
            const Icon = icons[i % icons.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ delay: i * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="group relative rounded-2xl border border-[#E5DFCE] bg-[#F2EEE3]/60 p-8 md:p-10 flex flex-col items-center justify-center text-center overflow-hidden hover:bg-[#0F3D2E] hover:text-[#FAF7F0] transition-colors duration-500 min-h-[260px] md:min-h-[280px]"
                data-testid={`ingredient-icon-${i}`}
              >
                <span className="inline-flex w-24 h-24 md:w-28 md:h-28 rounded-full border border-[#0F3D2E]/25 items-center justify-center text-[#2E8B4A] group-hover:border-[#2E8B4A] group-hover:bg-[#2E8B4A]/20 transition-colors mb-8">
                  <Icon size={44} strokeWidth={1.5} className="md:w-[52px] md:h-[52px]" />
                </span>

                <div className="font-serif-editorial text-[#0F3D2E] group-hover:text-[#FAF7F0] text-2xl md:text-[28px] leading-tight tracking-tight transition-colors">
                  {label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Ingredients;
